(() => {
 if(window.PrintIncAuth)return;
 /*
  PrintInc WhatsApp login session (token from the PrintInc Phone Checkout app).
  The shopper stays logged in until they press Log out: background checks (page load, scrolling,
  returning to the tab) never delete the saved login. Only logout() clears it. The app's own
  account page may still ask for a new code if the app's server-side session has expired.
 */
 const key='printinc.whatsapp.session.v1',profileKey='printinc.whatsapp.profile.v1',endpoint='/apps/phone-checkout';
 let volatile,checking,lastCheck=0,lastResult=null;
 const read=()=>{try{return localStorage.getItem(key)||volatile||null}catch{return volatile||null}};
 const profile=()=>{try{return JSON.parse(localStorage.getItem(profileKey)||'{}')||{}}catch{return {}}};
 const saveProfile=data=>{try{const old=profile();localStorage.setItem(profileKey,JSON.stringify({firstName:data.firstName||old.firstName||'',since:old.since||Date.now()}))}catch{}};
 function changed(){window.dispatchEvent(new Event('printinc:session-change'));if(parent!==window)parent.postMessage({type:'printinc:session-change'},new URL(document.baseURI).origin);}
 function remember(result){if(!/^[a-f0-9]{64}$/.test(result?.session||''))return;volatile=result.session;try{localStorage.setItem(key,result.session)}catch{}saveProfile(result);lastResult=null;lastCheck=0;changed();}
 function clear(){volatile=null;lastResult=null;try{localStorage.removeItem(key);localStorage.removeItem(profileKey)}catch{}changed();}
 async function request(action){const response=await fetch(endpoint,{method:'POST',cache:'no-store',headers:{'Content-Type':'application/json'},body:JSON.stringify({action,session:read()}),signal:AbortSignal.timeout(15000)});const data=await response.json();if(!response.ok)throw Error(data.error||'Unable to check your login.');return data;}
 // Saved login from this browser, no network: used to show "Account" instantly on every page.
 function local(){return read()?{loggedIn:true,firstName:profile().firstName||'',local:true}:{loggedIn:false};}
 async function status(){
  if(!read())return {loggedIn:false};
  if(lastResult&&Date.now()-lastCheck<300000)return lastResult; // at most one check every 5 minutes
  if(checking)return checking;
  checking=(async()=>{
   try{
    let data=await request('session');
    if(!data.loggedIn)data=await request('resume').catch(()=>data);
    if(data.loggedIn){saveProfile(data);lastResult={...data,loggedIn:true};}
    else lastResult={...local(),stale:true}; // keep the shopper logged in until they log out
    lastCheck=Date.now();return lastResult;
   }catch{return local();}finally{checking=null;}
  })();
  return checking;
 }
 window.PrintIncAuth={remember,local,status,
  async resume(){if(!read())return {loggedIn:false};const data=await request('resume');if(data.loggedIn)saveProfile(data);return data;},
  async logout(){try{await request('logout')}catch{}clear();}};
 window.addEventListener('storage',event=>{if(event.key===key){lastResult=null;window.dispatchEvent(new Event('printinc:session-change'));}});
})();
